

const initFacebookSdk = (id) => {
    return new Promise(() => {
        window.fbAsyncInit = function () {
            window.FB.init({
                appId: id,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v17.0'
            });
        };
        // load facebook sdk script
        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            js = d.createElement(s); js.id = id;
            js.src = 'https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v17.0';
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    });
}

function getFbSdk(id) {
    return new Promise(resolve => {
        if (window.FB) {
            resolve(window.FB)
        } else {
            initFacebookSdk(id)
            resolve(window.FB)
        }
    })
}



export default {
    initFacebookSdk,
    getFbSdk
}
export {
    initFacebookSdk,
    getFbSdk
}




